import { camelCaseToTitleCase } from 'components/account/jobs-v2/dropdowns/utils';
export const getRiskTableEntries = (risks) => {
    const entries = [];
    for (const risk of risks) {
        if ('changeType' in risk) {
            entries.push({
                title: new Date(risk.receivedAt).toLocaleString(),
                items: [{ label: 'Change Type', value: risk.changeType }]
            });
        }
        if (risk.akas.length > 0) {
            entries.push({
                title: 'AKA',
                items: [
                    {
                        label: 'Names',
                        value: risk.akas.join(', ')
                    }
                ]
            });
        }
        for (const listing of risk.listings) {
            entries.push({
                title: 'LISTING',
                items: [
                    {
                        label: 'AML Types',
                        value: listing.amlTypes.join(', ').toUpperCase()
                    },
                    ...(listing.listName
                        ? [{ label: 'Name', value: listing.listName.toUpperCase() }]
                        : []),
                    ...(listing.url ? [{ label: 'Url', value: listing.url }] : []),
                    ...(listing.listingStartedAt
                        ? [
                            {
                                label: 'Started',
                                value: new Date(listing.listingStartedAt).toLocaleString()
                            }
                        ]
                        : []),
                    ...(listing.listingEndedAt
                        ? [
                            {
                                label: 'Ended',
                                value: new Date(listing.listingEndedAt).toLocaleString()
                            }
                        ]
                        : []),
                    ...(listing.countryCodes.length > 0
                        ? [{ label: 'Countries', value: listing.countryCodes.join(', ') }]
                        : []),
                    ...(listing.politicalPositions.length > 0
                        ? [
                            {
                                label: 'Political Positions',
                                value: listing.politicalPositions.join(', ')
                            }
                        ]
                        : [])
                ]
            });
        }
    }
    return entries;
};
export const getRequestItemEntries = (request) => Object.entries(request).flatMap(([key, value]) => key !== 'callbackUrl' && key !== 'associatedJobId'
    ? [{ label: camelCaseToTitleCase(key), value }]
    : []);
